import { render, staticRenderFns } from "./FriendEdit.vue?vue&type=template&id=ba2d08fc&scoped=true&"
import script from "./FriendEdit.vue?vue&type=script&lang=js&"
export * from "./FriendEdit.vue?vue&type=script&lang=js&"
import style0 from "./FriendEdit.vue?vue&type=style&index=0&id=ba2d08fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2d08fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VAutocomplete,VAvatar,VBtn,VDatePicker,VDialog,VSpacer,VTimePicker})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba2d08fc')) {
      api.createRecord('ba2d08fc', component.options)
    } else {
      api.reload('ba2d08fc', component.options)
    }
    module.hot.accept("./FriendEdit.vue?vue&type=template&id=ba2d08fc&scoped=true&", function () {
      api.rerender('ba2d08fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FriendEdit.vue"
export default component.exports